import classNames from "classnames";
import React from "react";
import { twMerge } from "tailwind-merge";
import RippleEffect from "./RippleEffect";

const WhiteButton = ({
    as = 'button',
    href= '#',
    type = 'submit',
    processing,
    children,
    onClick,
    className = '',
    bgClass = '',
    outlineClass = '',
    textClass = '',
    isRounded = false,
    roundedClass = '',
    isShadow = false,
    shadowClass = '',
    ...attrs
}) => {
    const classBtn = classNames(
        'px-4 py-2 lg:px-10 lg:py-4 text-sm leading-none font-semibold ripple text-nowrap text-center',
        {
            'text-silk-blue': textClass === '',
            [textClass]: textClass !== '',
            'bg-white': bgClass === '',
            [bgClass]: bgClass !== '',
            [outlineClass]: outlineClass !== '',
            'rounded-full': isRounded && roundedClass === '',
            [roundedClass]: isRounded && roundedClass !== '',
            'shadow-lg': isShadow && shadowClass === '',
            [shadowClass]: isShadow && shadowClass !== '',
        },
        className,
    );

    return as === 'link' ? (
        <a href={href} onClick={onClick} className={twMerge(classBtn)} {...attrs}>
            {children}
            <RippleEffect />
        </a>
    ) : (
        <button
            type={type}
            onClick={onClick}
            className={twMerge(classBtn)}
            disabled={processing}
            {...attrs}
        >
            {children}
            <RippleEffect />
        </button>
    );
};

export default WhiteButton;
